<template>
    <app-layout>
        <hr class="w-12 main-bg h-1 mb-4 mx-auto mt-16">
        <h1 class="blue-text text-5xl font-bold text-center mb-12 px-4">{{ $t("airport.title") }}</h1>
        <div class="grid grid-cols-1 md:grid-cols-2 container mx-auto gap-6">
            <div class="mx-auto text-center">
                <h3 class="text-xl xl:text-3xl font-bold mb-2">{{ $t("airport.locs.loc1.title") }}</h3>
                <img class="w-[400px] h-[250px] lg:w-[650px] w-full lg:h-[350px] xl:h-[450px]" src="@/assets/png/la-airport.png" alt="">
                <p class="font-semibold text-md xl:text-2xl">{{ $t("airport.locs.loc1.notes.note1") }}</p>
                <p class="font-semibold text-md xl:text-2xl">{{ $t("airport.locs.loc1.notes.note2") }}</p>
                <p class="font-semibold text-md xl:text-2xl">{{ $t("airport.locs.loc1.notes.note3") }}</p>
            </div>
            <div class="mx-auto text-center">
                <h3 class="text-xl xl:text-3xl font-bold mb-2">{{ $t("airport.locs.loc2.title") }}</h3>
                <img class="w-[400px] h-[250px] lg:w-[650px] w-full lg:h-[350px] xl:h-[450px]" src="@/assets/png/sa-airport.jpeg" alt="">
                <p class="font-semibold text-md xl:text-2xl">{{ $t("airport.locs.loc2.notes.note1") }}</p>
                <p class="font-semibold text-md xl:text-2xl">{{ $t("airport.locs.loc2.notes.note2") }}</p>
                <p class="font-semibold text-md xl:text-2xl">{{ $t("airport.locs.loc2.notes.note3") }}</p>
            </div>
            <div class="mx-auto text-center">
                <h3 class="text-xl xl:text-3xl font-bold mb-2">{{ $t("airport.locs.loc3.title") }}</h3>
                <iframe
                    class="w-full max-w-xl rounded-xl h-80 mb-6"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2698.441129031359!2d-122.30030629999999!3d47.44233990000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x54905d47abf96451%3A0x7421a8b31cfb275f!2sICE%20International%20Currency%20Exchange!5e0!3m2!1sru!2skg!4v1760543602323!5m2!1sru!2skg" 
                    style="border:0;" 
                    allowfullscreen="" 
                    loading="lazy" 
                    referrerpolicy="no-referrer-when-downgrade"
                ></iframe>
                <p class="font-semibold text-md xl:text-2xl">{{ $t("airport.locs.loc3.notes.note1") }}</p>
                <p class="font-semibold text-md xl:text-2xl">{{ $t("airport.locs.loc3.notes.note2") }}</p>
                <p class="font-semibold text-md xl:text-2xl">{{ $t("airport.locs.loc3.notes.note3") }}</p>
            </div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from "@/layouts/AppLayout";
export default {
    name: "Airport",
    components: {AppLayout}
}
</script>

<style scoped>

</style>